import React, { Component } from "react";

class ErrorBoundary extends Component<
  { notifTrigger: () => void },
  { hasError: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.props.notifTrigger();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <></>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
